/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContactDTO } from './contactDTO';
import { OtherContactDTO } from './otherContactDTO';


export interface PatientInsertDTO { 
    /**
     * The patient's domicile address
     */
    addressDomicile?: string;
    /**
     * The patient's domicile address number
     */
    addressDomicileNumber?: string;
    /**
     * The patient's residence address
     */
    addressResidence?: string;
    /**
     * The patient's residence address number
     */
    addressResidenceNumber?: string;
    /**
     * The patient's asl
     */
    aslId?: string;
    /**
     * The patient's birth city
     */
    birthCityId?: string;
    /**
     * The patient's birth date
     */
    birthDate: Date;
    /**
     * The patient's blood group
     */
    bloodGroup?: string;
    /**
     * The post code of the city domicile
     */
    capDomicile?: string;
    /**
     * The post code of the city residence
     */
    capResidence?: string;
    /**
     * The patient's citizenship
     */
    citizenshipId: string;
    /**
     * The patient's domicile city
     */
    cityDomicileId?: string;
    /**
     * The patient's residence city
     */
    cityResidenceId?: string;
    /**
     * The patient's personal contacts
     */
    contacts: Array<ContactDTO>;
    /**
     * The patient's creation date
     */
    createDate?: Date;
    /**
     * The create user's uuid
     */
    createUserId?: string;
    /**
     * The district of the ASL to which the patient refers
     */
    districtId?: string;
    /**
     * The patient's health card
     */
    healthCard?: string;
    /**
     * The patient's marital status
     */
    maritalStatus?: number;
    /**
     * The patient's general doctor
     */
    mmg?: string;
    /**
     * The patient's name
     */
    name: string;
    /**
     * The neighborhood of the city domicile
     */
    neighborhoodDomicileId?: string;
    /**
     * The neighborhood of the city residence
     */
    neighborhoodId?: string;
    /**
     * The patient's contacts
     */
    otherContacts?: Array<OtherContactDTO>;
    /**
     * The patient's obsolete
     */
    patientObsolete?: boolean;
    /**
     * The type of assistance
     */
    serviceType?: string;
    /**
     * The patient's sex
     */
    sex: number;
    /**
     * The patient's  state domicile
     */
    stateDomicileId: string;
    /**
     * The patient's nationality
     */
    stateNationalityId: string;
    /**
     * The patient's  state residence
     */
    stateResidenceId: string;
    /**
     * The patient's study
     */
    study?: string;
    /**
     * The patient's surname
     */
    surname: string;
    /**
     * The patient's typeCode
     */
    typeCode?: string;
    /**
     * The patient's uniqueCode. Its can be CF, ENI code, STP code or TEAM Code
     */
    uniqueCode: string;
    /**
     * The patient's update date
     */
    updateDate?: Date;
    /**
     * The update user's uuid
     */
    updateUserId?: string;
    /**
     * The patient's uuid
     */
    uuid?: string;
}
